var map = {
	"./0.mp3": [
		10946,
		6292
	],
	"./1.mp3": [
		10947,
		6293
	],
	"./10.mp3": [
		10948,
		6294
	],
	"./11.mp3": [
		10949,
		6295
	],
	"./12.mp3": [
		10950,
		6296
	],
	"./13.mp3": [
		10951,
		6297
	],
	"./14.mp3": [
		10952,
		6298
	],
	"./15.mp3": [
		10953,
		6299
	],
	"./16.mp3": [
		10954,
		6300
	],
	"./17.mp3": [
		10955,
		6301
	],
	"./18.mp3": [
		10956,
		6302
	],
	"./19.mp3": [
		10957,
		6303
	],
	"./1st.mp3": [
		10958,
		6304
	],
	"./2.mp3": [
		10959,
		6305
	],
	"./20.mp3": [
		10960,
		6306
	],
	"./25.mp3": [
		10961,
		6307
	],
	"./2nd.mp3": [
		10962,
		6308
	],
	"./2s.mp3": [
		10963,
		6309
	],
	"./3.mp3": [
		10964,
		6310
	],
	"./30.mp3": [
		10965,
		6311
	],
	"./3rd.mp3": [
		10966,
		6312
	],
	"./4.mp3": [
		10967,
		6313
	],
	"./4th.mp3": [
		10968,
		6314
	],
	"./5.mp3": [
		10969,
		6315
	],
	"./5th.mp3": [
		10970,
		6316
	],
	"./6.mp3": [
		10971,
		6317
	],
	"./6th.mp3": [
		10972,
		6318
	],
	"./7.mp3": [
		10973,
		6319
	],
	"./7th.mp3": [
		10974,
		6320
	],
	"./8.mp3": [
		10975,
		6321
	],
	"./8th.mp3": [
		10976,
		6322
	],
	"./9.mp3": [
		10977,
		6323
	],
	"./9th.mp3": [
		10978,
		6324
	],
	"./a.mp3": [
		10979,
		6325
	],
	"./aa.mp3": [
		10980,
		6326
	],
	"./about.mp3": [
		10981,
		6327
	],
	"./after.mp3": [
		10982,
		6328
	],
	"./again.mp3": [
		10983,
		6329
	],
	"./air.mp3": [
		10984,
		6330
	],
	"./airplane.mp3": [
		10985,
		6331
	],
	"./alive.mp3": [
		10986,
		6332
	],
	"./all.mp3": [
		10987,
		6333
	],
	"./alligator.mp3": [
		10988,
		6334
	],
	"./alligators.mp3": [
		10989,
		6335
	],
	"./am.mp3": [
		10990,
		6336
	],
	"./ambulance.mp3": [
		10991,
		6337
	],
	"./amphibian.mp3": [
		10992,
		6338
	],
	"./amphibians.mp3": [
		10993,
		6339
	],
	"./an.mp3": [
		10994,
		6340
	],
	"./anchor.mp3": [
		10995,
		6341
	],
	"./and.mp3": [
		10996,
		6342
	],
	"./animal.mp3": [
		10997,
		6343
	],
	"./animals that live in the snow.mp3": [
		10998,
		6344
	],
	"./animals that live in trees.mp3": [
		10999,
		6345
	],
	"./animals with pouches.mp3": [
		11000,
		6346
	],
	"./animals without backbones.mp3": [
		11001,
		6347
	],
	"./animals.mp3": [
		11002,
		6348
	],
	"./ant.mp3": [
		11003,
		6349
	],
	"./anteater.mp3": [
		11004,
		6350
	],
	"./anteaters.mp3": [
		11005,
		6351
	],
	"./antennas.mp3": [
		11006,
		6352
	],
	"./ants.mp3": [
		11007,
		6353
	],
	"./aphid.mp3": [
		11008,
		6354
	],
	"./aphids.mp3": [
		11009,
		6355
	],
	"./apple.mp3": [
		11010,
		6356
	],
	"./arctic fox.mp3": [
		11011,
		6357
	],
	"./arctic wolf.mp3": [
		11012,
		6358
	],
	"./arctic.mp3": [
		11013,
		6359
	],
	"./are.mp3": [
		11014,
		6360
	],
	"./around.mp3": [
		11015,
		6361
	],
	"./as.mp3": [
		11016,
		6362
	],
	"./asleep.mp3": [
		11017,
		6363
	],
	"./astronaut.mp3": [
		11018,
		6364
	],
	"./astronauts.mp3": [
		11019,
		6365
	],
	"./at.mp3": [
		11020,
		6366
	],
	"./autumn.mp3": [
		11021,
		6367
	],
	"./away.mp3": [
		11022,
		6368
	],
	"./b.mp3": [
		11023,
		6369
	],
	"./babies.mp3": [
		11024,
		6370
	],
	"./baby animals.mp3": [
		11025,
		6371
	],
	"./baby.mp3": [
		11026,
		6372
	],
	"./back.mp3": [
		11027,
		6373
	],
	"./backbone.mp3": [
		11028,
		6374
	],
	"./backbones.mp3": [
		11029,
		6375
	],
	"./ball.mp3": [
		11030,
		6376
	],
	"./balloon.mp3": [
		11031,
		6377
	],
	"./balloons.mp3": [
		11032,
		6378
	],
	"./banana.mp3": [
		11033,
		6379
	],
	"./bananas.mp3": [
		11034,
		6380
	],
	"./banjo.mp3": [
		11035,
		6381
	],
	"./barn.mp3": [
		11036,
		6382
	],
	"./bat.mp3": [
		11037,
		6383
	],
	"./bathroom.mp3": [
		11038,
		6384
	],
	"./bathtub.mp3": [
		11039,
		6385
	],
	"./bb.mp3": [
		11040,
		6386
	],
	"./be.mp3": [
		11041,
		6387
	],
	"./bear.mp3": [
		11042,
		6388
	],
	"./bears.mp3": [
		11043,
		6389
	],
	"./beaver.mp3": [
		11044,
		6390
	],
	"./bed.mp3": [
		11045,
		6391
	],
	"./bedroom.mp3": [
		11046,
		6392
	],
	"./bee.mp3": [
		11047,
		6393
	],
	"./beehive.mp3": [
		11048,
		6394
	],
	"./been.mp3": [
		11049,
		6395
	],
	"./bees.mp3": [
		11050,
		6396
	],
	"./before.mp3": [
		11051,
		6397
	],
	"./begin.mp3": [
		11052,
		6398
	],
	"./begins.mp3": [
		11053,
		6399
	],
	"./big.mp3": [
		11054,
		6400
	],
	"./bighorn sheep.mp3": [
		11055,
		6401
	],
	"./bike.mp3": [
		11056,
		6402
	],
	"./bird.mp3": [
		11057,
		6403
	],
	"./birds.mp3": [
		11058,
		6404
	],
	"./black.mp3": [
		11059,
		6405
	],
	"./blood.mp3": [
		11060,
		6406
	],
	"./blooded.mp3": [
		11061,
		6407
	],
	"./blue.mp3": [
		11062,
		6408
	],
	"./boat.mp3": [
		11063,
		6409
	],
	"./boats.mp3": [
		11064,
		6410
	],
	"./bodies.mp3": [
		11065,
		6411
	],
	"./body parts.mp3": [
		11066,
		6412
	],
	"./body.mp3": [
		11067,
		6413
	],
	"./bone.mp3": [
		11068,
		6414
	],
	"./bones.mp3": [
		11069,
		6415
	],
	"./bongo.mp3": [
		11070,
		6416
	],
	"./book.mp3": [
		11071,
		6417
	],
	"./books.mp3": [
		11072,
		6418
	],
	"./born.mp3": [
		11073,
		6419
	],
	"./box.mp3": [
		11074,
		6420
	],
	"./boxer.mp3": [
		11075,
		6421
	],
	"./boxes.mp3": [
		11076,
		6422
	],
	"./boy.mp3": [
		11077,
		6423
	],
	"./branch.mp3": [
		11078,
		6424
	],
	"./branches.mp3": [
		11079,
		6425
	],
	"./breathe.mp3": [
		11080,
		6426
	],
	"./brown.mp3": [
		11081,
		6427
	],
	"./bumped.mp3": [
		11082,
		6428
	],
	"./bus.mp3": [
		11083,
		6429
	],
	"./but.mp3": [
		11084,
		6430
	],
	"./butterflies.mp3": [
		11085,
		6431
	],
	"./butterfly.mp3": [
		11086,
		6432
	],
	"./by.mp3": [
		11087,
		6433
	],
	"./bye.mp3": [
		11088,
		6434
	],
	"./c.mp3": [
		11089,
		6435
	],
	"./cage.mp3": [
		11090,
		6436
	],
	"./cake.mp3": [
		11091,
		6437
	],
	"./came.mp3": [
		11092,
		6438
	],
	"./camel.mp3": [
		11093,
		6439
	],
	"./can't.mp3": [
		11094,
		6440
	],
	"./can.mp3": [
		11095,
		6441
	],
	"./car.mp3": [
		11096,
		6442
	],
	"./carrot.mp3": [
		11097,
		6443
	],
	"./cars.mp3": [
		11098,
		6444
	],
	"./cat.mp3": [
		11099,
		6445
	],
	"./catch.mp3": [
		11100,
		6446
	],
	"./caterpillar.mp3": [
		11101,
		6447
	],
	"./cats.mp3": [
		11102,
		6448
	],
	"./cave.mp3": [
		11103,
		6449
	],
	"./caves.mp3": [
		11104,
		6450
	],
	"./cc.mp3": [
		11105,
		6451
	],
	"./cheese.mp3": [
		11106,
		6452
	],
	"./cheetah.mp3": [
		11107,
		6453
	],
	"./cherries.mp3": [
		11108,
		6454
	],
	"./cherry.mp3": [
		11109,
		6455
	],
	"./chick.mp3": [
		11110,
		6456
	],
	"./chicken.mp3": [
		11111,
		6457
	],
	"./chickens.mp3": [
		11112,
		6458
	],
	"./chicks.mp3": [
		11113,
		6459
	],
	"./chipmunk.mp3": [
		11114,
		6460
	],
	"./christmas tree.mp3": [
		11115,
		6461
	],
	"./christmas trees.mp3": [
		11116,
		6462
	],
	"./christmas.mp3": [
		11117,
		6463
	],
	"./circle.mp3": [
		11118,
		6464
	],
	"./circles.mp3": [
		11119,
		6465
	],
	"./clock.mp3": [
		11120,
		6466
	],
	"./clocks.mp3": [
		11121,
		6467
	],
	"./clothes.mp3": [
		11122,
		6468
	],
	"./cloud.mp3": [
		11123,
		6469
	],
	"./clouds.mp3": [
		11124,
		6470
	],
	"./cloudy.mp3": [
		11125,
		6471
	],
	"./clown fish.mp3": [
		11126,
		6472
	],
	"./clown.mp3": [
		11127,
		6473
	],
	"./cobra.mp3": [
		11128,
		6474
	],
	"./coconut.mp3": [
		11129,
		6475
	],
	"./cold.mp3": [
		11130,
		6476
	],
	"./collie.mp3": [
		11131,
		6477
	],
	"./colors.mp3": [
		11132,
		6478
	],
	"./come.mp3": [
		11133,
		6479
	],
	"./comes.mp3": [
		11134,
		6480
	],
	"./computer.mp3": [
		11135,
		6481
	],
	"./computers.mp3": [
		11136,
		6482
	],
	"./cone.mp3": [
		11137,
		6483
	],
	"./cones.mp3": [
		11138,
		6484
	],
	"./cookie.mp3": [
		11139,
		6485
	],
	"./cookies.mp3": [
		11140,
		6486
	],
	"./corgi.mp3": [
		11141,
		6487
	],
	"./corner.mp3": [
		11142,
		6488
	],
	"./corners.mp3": [
		11143,
		6489
	],
	"./couch.mp3": [
		11144,
		6490
	],
	"./could.mp3": [
		11145,
		6491
	],
	"./count.mp3": [
		11146,
		6492
	],
	"./cow.mp3": [
		11147,
		6493
	],
	"./cows.mp3": [
		11148,
		6494
	],
	"./crab.mp3": [
		11149,
		6495
	],
	"./crabs.mp3": [
		11150,
		6496
	],
	"./cream.mp3": [
		11151,
		6497
	],
	"./crocodile.mp3": [
		11152,
		6498
	],
	"./crocodiles.mp3": [
		11153,
		6499
	],
	"./cube.mp3": [
		11154,
		6500
	],
	"./cubes.mp3": [
		11155,
		6501
	],
	"./cup.mp3": [
		11156,
		6502
	],
	"./curran.mp3": [
		11157,
		6503
	],
	"./cylinder.mp3": [
		11158,
		6504
	],
	"./cylinders.mp3": [
		11159,
		6505
	],
	"./cymbal.mp3": [
		11160,
		6506
	],
	"./cymbals.mp3": [
		11161,
		6507
	],
	"./d.mp3": [
		11162,
		6508
	],
	"./dad.mp3": [
		11163,
		6509
	],
	"./dalmatian.mp3": [
		11164,
		6510
	],
	"./day.mp3": [
		11165,
		6511
	],
	"./dd.mp3": [
		11166,
		6512
	],
	"./deer.mp3": [
		11167,
		6513
	],
	"./desert animals.mp3": [
		11168,
		6514
	],
	"./desert.mp3": [
		11169,
		6515
	],
	"./deserts.mp3": [
		11170,
		6516
	],
	"./did.mp3": [
		11171,
		6517
	],
	"./different.mp3": [
		11172,
		6518
	],
	"./dinosaur.mp3": [
		11173,
		6519
	],
	"./dinosaurs.mp3": [
		11174,
		6520
	],
	"./diver.mp3": [
		11175,
		6521
	],
	"./do.mp3": [
		11176,
		6522
	],
	"./does.mp3": [
		11177,
		6523
	],
	"./dog.mp3": [
		11178,
		6524
	],
	"./dogs.mp3": [
		11179,
		6525
	],
	"./dolphin.mp3": [
		11180,
		6526
	],
	"./donkey.mp3": [
		11181,
		6527
	],
	"./dont.mp3": [
		11182,
		6528
	],
	"./down.mp3": [
		11183,
		6529
	],
	"./dragon.mp3": [
		11184,
		6530
	],
	"./dragonflies.mp3": [
		11185,
		6531
	],
	"./dragonfly.mp3": [
		11186,
		6532
	],
	"./dragons.mp3": [
		11187,
		6533
	],
	"./dress.mp3": [
		11188,
		6534
	],
	"./dresses.mp3": [
		11189,
		6535
	],
	"./drink.mp3": [
		11190,
		6536
	],
	"./drinks.mp3": [
		11191,
		6537
	],
	"./drum.mp3": [
		11192,
		6538
	],
	"./dry.mp3": [
		11193,
		6539
	],
	"./duck.mp3": [
		11194,
		6540
	],
	"./duckling.mp3": [
		11195,
		6541
	],
	"./ducklings.mp3": [
		11196,
		6542
	],
	"./ducks.mp3": [
		11197,
		6543
	],
	"./dump truck.mp3": [
		11198,
		6544
	],
	"./dump.mp3": [
		11199,
		6545
	],
	"./e.mp3": [
		11200,
		6546
	],
	"./eagle.mp3": [
		11201,
		6547
	],
	"./ear.mp3": [
		11202,
		6548
	],
	"./ears.mp3": [
		11203,
		6549
	],
	"./earth.mp3": [
		11204,
		6550
	],
	"./eat.mp3": [
		11205,
		6551
	],
	"./ee.mp3": [
		11206,
		6552
	],
	"./eel.mp3": [
		11207,
		6553
	],
	"./egg.mp3": [
		11208,
		6554
	],
	"./eight.mp3": [
		11209,
		6555
	],
	"./electricity.mp3": [
		11210,
		6556
	],
	"./elephant.mp3": [
		11211,
		6557
	],
	"./elephants.mp3": [
		11212,
		6558
	],
	"./else.mp3": [
		11213,
		6559
	],
	"./envelope.mp3": [
		11214,
		6560
	],
	"./equal.mp3": [
		11215,
		6561
	],
	"./equals.mp3": [
		11216,
		6562
	],
	"./eyes.mp3": [
		11217,
		6563
	],
	"./f.mp3": [
		11218,
		6564
	],
	"./face.mp3": [
		11219,
		6565
	],
	"./faces.mp3": [
		11220,
		6566
	],
	"./failing.mp3": [
		11221,
		6567
	],
	"./fall.mp3": [
		11222,
		6568
	],
	"./falling.mp3": [
		11223,
		6569
	],
	"./fan.mp3": [
		11224,
		6570
	],
	"./fans.mp3": [
		11225,
		6571
	],
	"./farm animals.mp3": [
		11226,
		6572
	],
	"./farm.mp3": [
		11227,
		6573
	],
	"./farmer.mp3": [
		11228,
		6574
	],
	"./farms.mp3": [
		11229,
		6575
	],
	"./fast.mp3": [
		11230,
		6576
	],
	"./faster.mp3": [
		11231,
		6577
	],
	"./fastest.mp3": [
		11232,
		6578
	],
	"./fat.mp3": [
		11233,
		6579
	],
	"./father.mp3": [
		11234,
		6580
	],
	"./fawn.mp3": [
		11235,
		6581
	],
	"./feathers.mp3": [
		11236,
		6582
	],
	"./feed.mp3": [
		11237,
		6583
	],
	"./feet.mp3": [
		11238,
		6584
	],
	"./fell.mp3": [
		11239,
		6585
	],
	"./fennec fox.mp3": [
		11240,
		6586
	],
	"./ff.mp3": [
		11241,
		6587
	],
	"./fiddle.mp3": [
		11242,
		6588
	],
	"./find.mp3": [
		11243,
		6589
	],
	"./fire truck.mp3": [
		11244,
		6590
	],
	"./fire.mp3": [
		11245,
		6591
	],
	"./first.mp3": [
		11246,
		6592
	],
	"./fish.mp3": [
		11247,
		6593
	],
	"./five.mp3": [
		11248,
		6594
	],
	"./flamingo.mp3": [
		11249,
		6595
	],
	"./flat.mp3": [
		11250,
		6596
	],
	"./float.mp3": [
		11251,
		6597
	],
	"./floats.mp3": [
		11252,
		6598
	],
	"./flower.mp3": [
		11253,
		6599
	],
	"./flowers.mp3": [
		11254,
		6600
	],
	"./fly.mp3": [
		11255,
		6601
	],
	"./flying animals.mp3": [
		11256,
		6602
	],
	"./flying fish.mp3": [
		11257,
		6603
	],
	"./flying.mp3": [
		11258,
		6604
	],
	"./food.mp3": [
		11259,
		6605
	],
	"./foot.mp3": [
		11260,
		6606
	],
	"./for.mp3": [
		11261,
		6607
	],
	"./forest animals.mp3": [
		11262,
		6608
	],
	"./forest.mp3": [
		11263,
		6609
	],
	"./forests.mp3": [
		11264,
		6610
	],
	"./four.mp3": [
		11265,
		6611
	],
	"./fox.mp3": [
		11266,
		6612
	],
	"./fridge.mp3": [
		11267,
		6613
	],
	"./friend.mp3": [
		11268,
		6614
	],
	"./frog.mp3": [
		11269,
		6615
	],
	"./frogs.mp3": [
		11270,
		6616
	],
	"./from.mp3": [
		11271,
		6617
	],
	"./frost.mp3": [
		11272,
		6618
	],
	"./frosty.mp3": [
		11273,
		6619
	],
	"./fun.mp3": [
		11274,
		6620
	],
	"./funny.mp3": [
		11275,
		6621
	],
	"./fur.mp3": [
		11276,
		6622
	],
	"./furniture.mp3": [
		11277,
		6623
	],
	"./furry.mp3": [
		11278,
		6624
	],
	"./g.mp3": [
		11279,
		6625
	],
	"./game.mp3": [
		11280,
		6626
	],
	"./games.mp3": [
		11281,
		6627
	],
	"./garden.mp3": [
		11282,
		6628
	],
	"./gate.mp3": [
		11283,
		6629
	],
	"./geese.mp3": [
		11284,
		6630
	],
	"./get.mp3": [
		11285,
		6631
	],
	"./gg.mp3": [
		11286,
		6632
	],
	"./gills.mp3": [
		11287,
		6633
	],
	"./gingerbread.mp3": [
		11288,
		6634
	],
	"./giraffe.mp3": [
		11289,
		6635
	],
	"./giraffes.mp3": [
		11290,
		6636
	],
	"./girl.mp3": [
		11291,
		6637
	],
	"./give.mp3": [
		11292,
		6638
	],
	"./go.mp3": [
		11293,
		6639
	],
	"./goal.mp3": [
		11294,
		6640
	],
	"./goat.mp3": [
		11295,
		6641
	],
	"./goats.mp3": [
		11296,
		6642
	],
	"./goes.mp3": [
		11297,
		6643
	],
	"./going.mp3": [
		11298,
		6644
	],
	"./goldfish.mp3": [
		11299,
		6645
	],
	"./good.mp3": [
		11300,
		6646
	],
	"./goose.mp3": [
		11301,
		6647
	],
	"./gorilla.mp3": [
		11302,
		6648
	],
	"./got.mp3": [
		11303,
		6649
	],
	"./grape.mp3": [
		11304,
		6650
	],
	"./grapes.mp3": [
		11305,
		6651
	],
	"./grass.mp3": [
		11306,
		6652
	],
	"./grasshopper.mp3": [
		11307,
		6653
	],
	"./grassland animals.mp3": [
		11308,
		6654
	],
	"./grassland.mp3": [
		11309,
		6655
	],
	"./gray.mp3": [
		11310,
		6656
	],
	"./green.mp3": [
		11311,
		6657
	],
	"./grey.mp3": [
		11312,
		6658
	],
	"./grow.mp3": [
		11313,
		6659
	],
	"./grows.mp3": [
		11314,
		6660
	],
	"./guitar.mp3": [
		11315,
		6661
	],
	"./h.mp3": [
		11316,
		6662
	],
	"./habitats.mp3": [
		11317,
		6663
	],
	"./had.mp3": [
		11318,
		6664
	],
	"./hair.mp3": [
		11319,
		6665
	],
	"./hammer.mp3": [
		11320,
		6666
	],
	"./hammerhead shark.mp3": [
		11321,
		6667
	],
	"./hammerhead.mp3": [
		11322,
		6668
	],
	"./hand.mp3": [
		11323,
		6669
	],
	"./hard.mp3": [
		11324,
		6670
	],
	"./harp.mp3": [
		11325,
		6671
	],
	"./harps.mp3": [
		11326,
		6672
	],
	"./has.mp3": [
		11327,
		6673
	],
	"./hat.mp3": [
		11328,
		6674
	],
	"./hats.mp3": [
		11329,
		6675
	],
	"./have.mp3": [
		11330,
		6676
	],
	"./hay.mp3": [
		11331,
		6677
	],
	"./he.mp3": [
		11332,
		6678
	],
	"./head.mp3": [
		11333,
		6679
	],
	"./heads.mp3": [
		11334,
		6680
	],
	"./heart.mp3": [
		11335,
		6681
	],
	"./hedgehog.mp3": [
		11336,
		6682
	],
	"./helicopter.mp3": [
		11337,
		6683
	],
	"./helicopters.mp3": [
		11338,
		6684
	],
	"./hello.mp3": [
		11339,
		6685
	],
	"./helmets.mp3": [
		11340,
		6686
	],
	"./help.mp3": [
		11341,
		6687
	],
	"./her.mp3": [
		11342,
		6688
	],
	"./here.mp3": [
		11343,
		6689
	],
	"./hermit crab.mp3": [
		11344,
		6690
	],
	"./hermit.mp3": [
		11345,
		6691
	],
	"./hexagon.mp3": [
		11346,
		6692
	],
	"./hexagons.mp3": [
		11347,
		6693
	],
	"./hh.mp3": [
		11348,
		6694
	],
	"./hide.mp3": [
		11349,
		6695
	],
	"./him.mp3": [
		11350,
		6696
	],
	"./hippo.mp3": [
		11351,
		6697
	],
	"./hippos.mp3": [
		11352,
		6698
	],
	"./his.mp3": [
		11353,
		6699
	],
	"./home.mp3": [
		11354,
		6700
	],
	"./homes.mp3": [
		11355,
		6701
	],
	"./hoof.mp3": [
		11356,
		6702
	],
	"./horn.mp3": [
		11357,
		6703
	],
	"./horns.mp3": [
		11358,
		6704
	],
	"./horse.mp3": [
		11359,
		6705
	],
	"./horses.mp3": [
		11360,
		6706
	],
	"./hot-air balloon.mp3": [
		11361,
		6707
	],
	"./hot.mp3": [
		11362,
		6708
	],
	"./hour.mp3": [
		11363,
		6709
	],
	"./house.mp3": [
		11364,
		6710
	],
	"./houses.mp3": [
		11365,
		6711
	],
	"./how.mp3": [
		11366,
		6712
	],
	"./huge.mp3": [
		11367,
		6713
	],
	"./hummingbird.mp3": [
		11368,
		6714
	],
	"./humps.mp3": [
		11369,
		6715
	],
	"./hungry.mp3": [
		11370,
		6716
	],
	"./i'm.mp3": [
		11371,
		6717
	],
	"./i.mp3": [
		11372,
		6718
	],
	"./ice cream.mp3": [
		11373,
		6719
	],
	"./ice skates.mp3": [
		11374,
		6720
	],
	"./ice.mp3": [
		11375,
		6721
	],
	"./iceberg.mp3": [
		11376,
		6722
	],
	"./if.mp3": [
		11377,
		6723
	],
	"./igloo.mp3": [
		11378,
		6724
	],
	"./iguana.mp3": [
		11379,
		6725
	],
	"./ii.mp3": [
		11380,
		6726
	],
	"./in.mp3": [
		11381,
		6727
	],
	"./ink.mp3": [
		11382,
		6728
	],
	"./insect.mp3": [
		11383,
		6729
	],
	"./insects.mp3": [
		11384,
		6730
	],
	"./inside.mp3": [
		11385,
		6731
	],
	"./into.mp3": [
		11386,
		6732
	],
	"./is.mp3": [
		11387,
		6733
	],
	"./island.mp3": [
		11388,
		6734
	],
	"./it.mp3": [
		11389,
		6735
	],
	"./its.mp3": [
		11390,
		6736
	],
	"./j.mp3": [
		11391,
		6737
	],
	"./jack-in-the-box.mp3": [
		11392,
		6738
	],
	"./jacket.mp3": [
		11393,
		6739
	],
	"./jaguar.mp3": [
		11394,
		6740
	],
	"./jar.mp3": [
		11395,
		6741
	],
	"./jeans.mp3": [
		11396,
		6742
	],
	"./jeep.mp3": [
		11397,
		6743
	],
	"./jelly.mp3": [
		11398,
		6744
	],
	"./jellyfish.mp3": [
		11399,
		6745
	],
	"./jenkins.mp3": [
		11400,
		6746
	],
	"./jenny.mp3": [
		11401,
		6747
	],
	"./jj.mp3": [
		11402,
		6748
	],
	"./juggler.mp3": [
		11403,
		6749
	],
	"./jump.mp3": [
		11404,
		6750
	],
	"./jumped.mp3": [
		11405,
		6751
	],
	"./jumping.mp3": [
		11406,
		6752
	],
	"./jupiter.mp3": [
		11407,
		6753
	],
	"./just.mp3": [
		11408,
		6754
	],
	"./k.mp3": [
		11409,
		6755
	],
	"./kangaroo.mp3": [
		11410,
		6756
	],
	"./kangaroos.mp3": [
		11411,
		6757
	],
	"./key.mp3": [
		11412,
		6758
	],
	"./keys.mp3": [
		11413,
		6759
	],
	"./kick.mp3": [
		11414,
		6760
	],
	"./kicks.mp3": [
		11415,
		6761
	],
	"./kid.mp3": [
		11416,
		6762
	],
	"./kids.mp3": [
		11417,
		6763
	],
	"./king.mp3": [
		11418,
		6764
	],
	"./kings.mp3": [
		11419,
		6765
	],
	"./kitchen.mp3": [
		11420,
		6766
	],
	"./kite.mp3": [
		11421,
		6767
	],
	"./kitten.mp3": [
		11422,
		6768
	],
	"./kittens.mp3": [
		11423,
		6769
	],
	"./kk.mp3": [
		11424,
		6770
	],
	"./know.mp3": [
		11425,
		6771
	],
	"./koala.mp3": [
		11426,
		6772
	],
	"./l.mp3": [
		11427,
		6773
	],
	"./ladder.mp3": [
		11428,
		6774
	],
	"./ladybug.mp3": [
		11429,
		6775
	],
	"./lake.mp3": [
		11430,
		6776
	],
	"./lakes.mp3": [
		11431,
		6777
	],
	"./lamb.mp3": [
		11432,
		6778
	],
	"./lambs.mp3": [
		11433,
		6779
	],
	"./land.mp3": [
		11434,
		6780
	],
	"./last.mp3": [
		11435,
		6781
	],
	"./leaf.mp3": [
		11436,
		6782
	],
	"./leaves.mp3": [
		11437,
		6783
	],
	"./legs.mp3": [
		11438,
		6784
	],
	"./lemon.mp3": [
		11439,
		6785
	],
	"./lemons.mp3": [
		11440,
		6786
	],
	"./let's.mp3": [
		11441,
		6787
	],
	"./lets.mp3": [
		11442,
		6788
	],
	"./letter.mp3": [
		11443,
		6789
	],
	"./libby.mp3": [
		11444,
		6790
	],
	"./light.mp3": [
		11445,
		6791
	],
	"./lights.mp3": [
		11446,
		6792
	],
	"./like.mp3": [
		11447,
		6793
	],
	"./liked.mp3": [
		11448,
		6794
	],
	"./likes.mp3": [
		11449,
		6795
	],
	"./lion cub.mp3": [
		11450,
		6796
	],
	"./lion.mp3": [
		11451,
		6797
	],
	"./lioness.mp3": [
		11452,
		6798
	],
	"./lions.mp3": [
		11453,
		6799
	],
	"./liquid.mp3": [
		11454,
		6800
	],
	"./listen.mp3": [
		11455,
		6801
	],
	"./little.mp3": [
		11456,
		6802
	],
	"./live.mp3": [
		11457,
		6803
	],
	"./lives.mp3": [
		11458,
		6804
	],
	"./living room.mp3": [
		11459,
		6805
	],
	"./living.mp3": [
		11460,
		6806
	],
	"./lizard.mp3": [
		11461,
		6807
	],
	"./lizards.mp3": [
		11462,
		6808
	],
	"./ll.mp3": [
		11463,
		6809
	],
	"./lobster.mp3": [
		11464,
		6810
	],
	"./log.mp3": [
		11465,
		6811
	],
	"./lollipops.mp3": [
		11466,
		6812
	],
	"./long neck dinosaur.mp3": [
		11467,
		6813
	],
	"./long.mp3": [
		11468,
		6814
	],
	"./look.mp3": [
		11469,
		6815
	],
	"./looked.mp3": [
		11470,
		6816
	],
	"./looking.mp3": [
		11471,
		6817
	],
	"./loud.mp3": [
		11472,
		6818
	],
	"./love.mp3": [
		11473,
		6819
	],
	"./loves.mp3": [
		11474,
		6820
	],
	"./lung.mp3": [
		11475,
		6821
	],
	"./lungs.mp3": [
		11476,
		6822
	],
	"./m.mp3": [
		11477,
		6823
	],
	"./made.mp3": [
		11478,
		6824
	],
	"./magnet.mp3": [
		11479,
		6825
	],
	"./magnets.mp3": [
		11480,
		6826
	],
	"./make believe.mp3": [
		11481,
		6827
	],
	"./make-believe.mp3": [
		11482,
		6828
	],
	"./make.mp3": [
		11483,
		6829
	],
	"./makes.mp3": [
		11484,
		6830
	],
	"./making.mp3": [
		11485,
		6831
	],
	"./mammal.mp3": [
		11486,
		6832
	],
	"./mammals.mp3": [
		11487,
		6833
	],
	"./man.mp3": [
		11488,
		6834
	],
	"./many.mp3": [
		11489,
		6835
	],
	"./map.mp3": [
		11490,
		6836
	],
	"./mark.mp3": [
		11491,
		6837
	],
	"./mars.mp3": [
		11492,
		6838
	],
	"./math.mp3": [
		11493,
		6839
	],
	"./me.mp3": [
		11494,
		6840
	],
	"./meat eaters.mp3": [
		11495,
		6841
	],
	"./meat.mp3": [
		11496,
		6842
	],
	"./meet.mp3": [
		11497,
		6843
	],
	"./mercury.mp3": [
		11498,
		6844
	],
	"./merry.mp3": [
		11499,
		6845
	],
	"./metal.mp3": [
		11500,
		6846
	],
	"./mice.mp3": [
		11501,
		6847
	],
	"./milk.mp3": [
		11502,
		6848
	],
	"./mitten.mp3": [
		11503,
		6849
	],
	"./mittens.mp3": [
		11504,
		6850
	],
	"./mm.mp3": [
		11505,
		6851
	],
	"./mom.mp3": [
		11506,
		6852
	],
	"./monkey.mp3": [
		11507,
		6853
	],
	"./monkeys.mp3": [
		11508,
		6854
	],
	"./monster.mp3": [
		11509,
		6855
	],
	"./monsters.mp3": [
		11510,
		6856
	],
	"./moon.mp3": [
		11511,
		6857
	],
	"./moose.mp3": [
		11512,
		6858
	],
	"./more.mp3": [
		11513,
		6859
	],
	"./most.mp3": [
		11514,
		6860
	],
	"./mother.mp3": [
		11515,
		6861
	],
	"./motorcycle.mp3": [
		11516,
		6862
	],
	"./mountain.mp3": [
		11517,
		6863
	],
	"./mountains.mp3": [
		11518,
		6864
	],
	"./mouse.mp3": [
		11519,
		6865
	],
	"./mouth.mp3": [
		11520,
		6866
	],
	"./move.mp3": [
		11521,
		6867
	],
	"./music.mp3": [
		11522,
		6868
	],
	"./musical instruments.mp3": [
		11523,
		6869
	],
	"./must.mp3": [
		11524,
		6870
	],
	"./my.mp3": [
		11525,
		6871
	],
	"./n.mp3": [
		11526,
		6872
	],
	"./nail.mp3": [
		11527,
		6873
	],
	"./nature.mp3": [
		11528,
		6874
	],
	"./neck.mp3": [
		11529,
		6875
	],
	"./necklace.mp3": [
		11530,
		6876
	],
	"./necks.mp3": [
		11531,
		6877
	],
	"./need.mp3": [
		11532,
		6878
	],
	"./neptune.mp3": [
		11533,
		6879
	],
	"./nest.mp3": [
		11534,
		6880
	],
	"./net.mp3": [
		11535,
		6881
	],
	"./new.mp3": [
		11536,
		6882
	],
	"./next.mp3": [
		11537,
		6883
	],
	"./night.mp3": [
		11538,
		6884
	],
	"./nine.mp3": [
		11539,
		6885
	],
	"./nn.mp3": [
		11540,
		6886
	],
	"./no.mp3": [
		11541,
		6887
	],
	"./nocturnal animals.mp3": [
		11542,
		6888
	],
	"./nose.mp3": [
		11543,
		6889
	],
	"./noses.mp3": [
		11544,
		6890
	],
	"./not.mp3": [
		11545,
		6891
	],
	"./now.mp3": [
		11546,
		6892
	],
	"./numbers.mp3": [
		11547,
		6893
	],
	"./nut.mp3": [
		11548,
		6894
	],
	"./nuts.mp3": [
		11549,
		6895
	],
	"./o.mp3": [
		11550,
		6896
	],
	"./oar.mp3": [
		11551,
		6897
	],
	"./ocean.mp3": [
		11552,
		6898
	],
	"./oclock.mp3": [
		11553,
		6899
	],
	"./octagon.mp3": [
		11554,
		6900
	],
	"./octagons.mp3": [
		11555,
		6901
	],
	"./octopus.mp3": [
		11556,
		6902
	],
	"./of.mp3": [
		11557,
		6903
	],
	"./off.mp3": [
		11558,
		6904
	],
	"./oh.mp3": [
		11559,
		6905
	],
	"./okay.mp3": [
		11560,
		6906
	],
	"./on.mp3": [
		11561,
		6907
	],
	"./one.mp3": [
		11562,
		6908
	],
	"./only.mp3": [
		11563,
		6909
	],
	"./oo.mp3": [
		11564,
		6910
	],
	"./or.mp3": [
		11565,
		6911
	],
	"./orange.mp3": [
		11566,
		6912
	],
	"./oranges.mp3": [
		11567,
		6913
	],
	"./orangutan.mp3": [
		11568,
		6914
	],
	"./ore.mp3": [
		11569,
		6915
	],
	"./ostrich.mp3": [
		11570,
		6916
	],
	"./otter.mp3": [
		11571,
		6917
	],
	"./our.mp3": [
		11572,
		6918
	],
	"./out.mp3": [
		11573,
		6919
	],
	"./over.mp3": [
		11574,
		6920
	],
	"./owl.mp3": [
		11575,
		6921
	],
	"./ox.mp3": [
		11576,
		6922
	],
	"./p.mp3": [
		11577,
		6923
	],
	"./paint.mp3": [
		11578,
		6924
	],
	"./painting.mp3": [
		11579,
		6925
	],
	"./panda.mp3": [
		11580,
		6926
	],
	"./pandas.mp3": [
		11581,
		6927
	],
	"./parachute.mp3": [
		11582,
		6928
	],
	"./parrot.mp3": [
		11583,
		6929
	],
	"./party.mp3": [
		11584,
		6930
	],
	"./peacock.mp3": [
		11585,
		6931
	],
	"./pelican.mp3": [
		11586,
		6932
	],
	"./pelicans.mp3": [
		11587,
		6933
	],
	"./penguin.mp3": [
		11588,
		6934
	],
	"./penguins.mp3": [
		11589,
		6935
	],
	"./pentagon.mp3": [
		11590,
		6936
	],
	"./pentagons.mp3": [
		11591,
		6937
	],
	"./people.mp3": [
		11592,
		6938
	],
	"./pet.mp3": [
		11593,
		6939
	],
	"./pets.mp3": [
		11594,
		6940
	],
	"./piano.mp3": [
		11595,
		6941
	],
	"./pig.mp3": [
		11596,
		6942
	],
	"./piglet.mp3": [
		11597,
		6943
	],
	"./piglets.mp3": [
		11598,
		6944
	],
	"./pink.mp3": [
		11599,
		6945
	],
	"./pirate.mp3": [
		11600,
		6946
	],
	"./places.mp3": [
		11601,
		6947
	],
	"./plain.mp3": [
		11602,
		6948
	],
	"./plains.mp3": [
		11603,
		6949
	],
	"./plane.mp3": [
		11604,
		6950
	],
	"./planes.mp3": [
		11605,
		6951
	],
	"./planet.mp3": [
		11606,
		6952
	],
	"./planets.mp3": [
		11607,
		6953
	],
	"./plant eaters.mp3": [
		11608,
		6954
	],
	"./plant.mp3": [
		11609,
		6955
	],
	"./plants.mp3": [
		11610,
		6956
	],
	"./play.mp3": [
		11611,
		6957
	],
	"./playground.mp3": [
		11612,
		6958
	],
	"./playing.mp3": [
		11613,
		6959
	],
	"./polar bear cub.mp3": [
		11614,
		6960
	],
	"./polar bear.mp3": [
		11615,
		6961
	],
	"./polar.mp3": [
		11616,
		6962
	],
	"./pond animals.mp3": [
		11617,
		6963
	],
	"./pond.mp3": [
		11618,
		6964
	],
	"./ponds.mp3": [
		11619,
		6965
	],
	"./poodle.mp3": [
		11620,
		6966
	],
	"./pp.mp3": [
		11621,
		6967
	],
	"./praying mantis.mp3": [
		11622,
		6968
	],
	"./praying mantises.mp3": [
		11623,
		6969
	],
	"./present.mp3": [
		11624,
		6970
	],
	"./presents.mp3": [
		11625,
		6971
	],
	"./ptarmigan.mp3": [
		11626,
		6972
	],
	"./ptarmigans.mp3": [
		11627,
		6973
	],
	"./pterosaur.mp3": [
		11628,
		6974
	],
	"./pull.mp3": [
		11629,
		6975
	],
	"./pulley.mp3": [
		11630,
		6976
	],
	"./pulleys.mp3": [
		11631,
		6977
	],
	"./pulls.mp3": [
		11632,
		6978
	],
	"./pumpkin.mp3": [
		11633,
		6979
	],
	"./pumpkins.mp3": [
		11634,
		6980
	],
	"./pup.mp3": [
		11635,
		6981
	],
	"./puppies.mp3": [
		11636,
		6982
	],
	"./puppy.mp3": [
		11637,
		6983
	],
	"./purple.mp3": [
		11638,
		6984
	],
	"./put.mp3": [
		11639,
		6985
	],
	"./pyramid.mp3": [
		11640,
		6986
	],
	"./pyramids.mp3": [
		11641,
		6987
	],
	"./q.mp3": [
		11642,
		6988
	],
	"./qq.mp3": [
		11643,
		6989
	],
	"./quarter.mp3": [
		11644,
		6990
	],
	"./quarters.mp3": [
		11645,
		6991
	],
	"./queen.mp3": [
		11646,
		6992
	],
	"./question mark.mp3": [
		11647,
		6993
	],
	"./question.mp3": [
		11648,
		6994
	],
	"./quilt.mp3": [
		11649,
		6995
	],
	"./quotation marks.mp3": [
		11650,
		6996
	],
	"./r.mp3": [
		11651,
		6997
	],
	"./rabbit.mp3": [
		11652,
		6998
	],
	"./rabbits.mp3": [
		11653,
		6999
	],
	"./raccoon.mp3": [
		11654,
		7000
	],
	"./race.mp3": [
		11655,
		7001
	],
	"./racoon.mp3": [
		11656,
		7002
	],
	"./rain.mp3": [
		11657,
		7003
	],
	"./rainbow.mp3": [
		11658,
		7004
	],
	"./rainforest.mp3": [
		11659,
		7005
	],
	"./rainforests.mp3": [
		11660,
		7006
	],
	"./rainy.mp3": [
		11661,
		7007
	],
	"./raptor.mp3": [
		11662,
		7008
	],
	"./rat.mp3": [
		11663,
		7009
	],
	"./rats.mp3": [
		11664,
		7010
	],
	"./read.mp3": [
		11665,
		7011
	],
	"./real.mp3": [
		11666,
		7012
	],
	"./rectangle.mp3": [
		11667,
		7013
	],
	"./rectangles.mp3": [
		11668,
		7014
	],
	"./rectangular prism.mp3": [
		11669,
		7015
	],
	"./rectangular prisms.mp3": [
		11670,
		7016
	],
	"./red.mp3": [
		11671,
		7017
	],
	"./refrigerator.mp3": [
		11672,
		7018
	],
	"./reindeer.mp3": [
		11673,
		7019
	],
	"./reptile.mp3": [
		11674,
		7020
	],
	"./reptiles.mp3": [
		11675,
		7021
	],
	"./rhino.mp3": [
		11676,
		7022
	],
	"./rhinos.mp3": [
		11677,
		7023
	],
	"./ride.mp3": [
		11678,
		7024
	],
	"./river.mp3": [
		11679,
		7025
	],
	"./rivers.mp3": [
		11680,
		7026
	],
	"./road.mp3": [
		11681,
		7027
	],
	"./roads.mp3": [
		11682,
		7028
	],
	"./robot.mp3": [
		11683,
		7029
	],
	"./rocket.mp3": [
		11684,
		7030
	],
	"./rockets.mp3": [
		11685,
		7031
	],
	"./rocking.mp3": [
		11686,
		7032
	],
	"./rocks.mp3": [
		11687,
		7033
	],
	"./rode.mp3": [
		11688,
		7034
	],
	"./room.mp3": [
		11689,
		7035
	],
	"./rooms.mp3": [
		11690,
		7036
	],
	"./rooster.mp3": [
		11691,
		7037
	],
	"./root.mp3": [
		11692,
		7038
	],
	"./roots.mp3": [
		11693,
		7039
	],
	"./round.mp3": [
		11694,
		7040
	],
	"./rr.mp3": [
		11695,
		7041
	],
	"./run.mp3": [
		11696,
		7042
	],
	"./running.mp3": [
		11697,
		7043
	],
	"./runs.mp3": [
		11698,
		7044
	],
	"./s.mp3": [
		11699,
		7045
	],
	"./said.mp3": [
		11700,
		7046
	],
	"./salamander.mp3": [
		11701,
		7047
	],
	"./sam.mp3": [
		11702,
		7048
	],
	"./sandcastle.mp3": [
		11703,
		7049
	],
	"./sandcastles.mp3": [
		11704,
		7050
	],
	"./santa.mp3": [
		11705,
		7051
	],
	"./sat.mp3": [
		11706,
		7052
	],
	"./satellite.mp3": [
		11707,
		7053
	],
	"./satellites.mp3": [
		11708,
		7054
	],
	"./saturn.mp3": [
		11709,
		7055
	],
	"./saw.mp3": [
		11710,
		7056
	],
	"./saxophones.mp3": [
		11711,
		7057
	],
	"./scales.mp3": [
		11712,
		7058
	],
	"./scaly.mp3": [
		11713,
		7059
	],
	"./scarf.mp3": [
		11714,
		7060
	],
	"./scene.mp3": [
		11715,
		7061
	],
	"./school.mp3": [
		11716,
		7062
	],
	"./science.mp3": [
		11717,
		7063
	],
	"./scuba diver.mp3": [
		11718,
		7064
	],
	"./scuba.mp3": [
		11719,
		7065
	],
	"./sea animals.mp3": [
		11720,
		7066
	],
	"./sea snake.mp3": [
		11721,
		7067
	],
	"./sea turtle.mp3": [
		11722,
		7068
	],
	"./sea turtles.mp3": [
		11723,
		7069
	],
	"./sea.mp3": [
		11724,
		7070
	],
	"./seagull.mp3": [
		11725,
		7071
	],
	"./seahorse.mp3": [
		11726,
		7072
	],
	"./seahorses.mp3": [
		11727,
		7073
	],
	"./seal pup.mp3": [
		11728,
		7074
	],
	"./seal.mp3": [
		11729,
		7075
	],
	"./seas.mp3": [
		11730,
		7076
	],
	"./see.mp3": [
		11731,
		7077
	],
	"./seed.mp3": [
		11732,
		7078
	],
	"./seeds.mp3": [
		11733,
		7079
	],
	"./seen.mp3": [
		11734,
		7080
	],
	"./sees.mp3": [
		11735,
		7081
	],
	"./seesaw.mp3": [
		11736,
		7082
	],
	"./seize.mp3": [
		11737,
		7083
	],
	"./seven.mp3": [
		11738,
		7084
	],
	"./shape.mp3": [
		11739,
		7085
	],
	"./shapes.mp3": [
		11740,
		7086
	],
	"./shark.mp3": [
		11741,
		7087
	],
	"./sharks.mp3": [
		11742,
		7088
	],
	"./sharp.mp3": [
		11743,
		7089
	],
	"./she.mp3": [
		11744,
		7090
	],
	"./sheep.mp3": [
		11745,
		7091
	],
	"./shell.mp3": [
		11746,
		7092
	],
	"./shells.mp3": [
		11747,
		7093
	],
	"./shirt.mp3": [
		11748,
		7094
	],
	"./shirts.mp3": [
		11749,
		7095
	],
	"./short.mp3": [
		11750,
		7096
	],
	"./shouted.mp3": [
		11751,
		7097
	],
	"./shower.mp3": [
		11752,
		7098
	],
	"./shrimp.mp3": [
		11753,
		7099
	],
	"./side.mp3": [
		11754,
		7100
	],
	"./sides.mp3": [
		11755,
		7101
	],
	"./sighed.mp3": [
		11756,
		7102
	],
	"./sink.mp3": [
		11757,
		7103
	],
	"./sinks.mp3": [
		11758,
		7104
	],
	"./sit.mp3": [
		11759,
		7105
	],
	"./sitting.mp3": [
		11760,
		7106
	],
	"./six.mp3": [
		11761,
		7107
	],
	"./skate.mp3": [
		11762,
		7108
	],
	"./skates.mp3": [
		11763,
		7109
	],
	"./skating.mp3": [
		11764,
		7110
	],
	"./skin.mp3": [
		11765,
		7111
	],
	"./skunk.mp3": [
		11766,
		7112
	],
	"./skunks.mp3": [
		11767,
		7113
	],
	"./sky.mp3": [
		11768,
		7114
	],
	"./sled.mp3": [
		11769,
		7115
	],
	"./sleeping.mp3": [
		11770,
		7116
	],
	"./sleigh.mp3": [
		11771,
		7117
	],
	"./slide.mp3": [
		11772,
		7118
	],
	"./sliding.mp3": [
		11773,
		7119
	],
	"./slug.mp3": [
		11774,
		7120
	],
	"./slugs.mp3": [
		11775,
		7121
	],
	"./small.mp3": [
		11776,
		7122
	],
	"./snail.mp3": [
		11777,
		7123
	],
	"./snails.mp3": [
		11778,
		7124
	],
	"./snake.mp3": [
		11779,
		7125
	],
	"./snakes.mp3": [
		11780,
		7126
	],
	"./snow.mp3": [
		11781,
		7127
	],
	"./snowball.mp3": [
		11782,
		7128
	],
	"./snowing.mp3": [
		11783,
		7129
	],
	"./snowman's.mp3": [
		11784,
		7130
	],
	"./snowman.mp3": [
		11785,
		7131
	],
	"./snowmen.mp3": [
		11786,
		7132
	],
	"./snowshoe rabbit.mp3": [
		11787,
		7133
	],
	"./snowy owl.mp3": [
		11788,
		7134
	],
	"./snowy.mp3": [
		11789,
		7135
	],
	"./so.mp3": [
		11790,
		7136
	],
	"./soccer.mp3": [
		11791,
		7137
	],
	"./sock.mp3": [
		11792,
		7138
	],
	"./socks.mp3": [
		11793,
		7139
	],
	"./soft.mp3": [
		11794,
		7140
	],
	"./soil.mp3": [
		11795,
		7141
	],
	"./solid.mp3": [
		11796,
		7142
	],
	"./some.mp3": [
		11797,
		7143
	],
	"./something.mp3": [
		11798,
		7144
	],
	"./son.mp3": [
		11799,
		7145
	],
	"./soon.mp3": [
		11800,
		7146
	],
	"./sow.mp3": [
		11801,
		7147
	],
	"./space.mp3": [
		11802,
		7148
	],
	"./spaceship.mp3": [
		11803,
		7149
	],
	"./spaceships.mp3": [
		11804,
		7150
	],
	"./sphere.mp3": [
		11805,
		7151
	],
	"./spheres.mp3": [
		11806,
		7152
	],
	"./spider.mp3": [
		11807,
		7153
	],
	"./spiders.mp3": [
		11808,
		7154
	],
	"./spots.mp3": [
		11809,
		7155
	],
	"./spring.mp3": [
		11810,
		7156
	],
	"./spy.mp3": [
		11811,
		7157
	],
	"./square.mp3": [
		11812,
		7158
	],
	"./squares.mp3": [
		11813,
		7159
	],
	"./squid.mp3": [
		11814,
		7160
	],
	"./squirrel.mp3": [
		11815,
		7161
	],
	"./squirrels.mp3": [
		11816,
		7162
	],
	"./ss.mp3": [
		11817,
		7163
	],
	"./star.mp3": [
		11818,
		7164
	],
	"./starfish.mp3": [
		11819,
		7165
	],
	"./stars.mp3": [
		11820,
		7166
	],
	"./stegosaurus.mp3": [
		11821,
		7167
	],
	"./stem.mp3": [
		11822,
		7168
	],
	"./stems.mp3": [
		11823,
		7169
	],
	"./stocking.mp3": [
		11824,
		7170
	],
	"./stockings.mp3": [
		11825,
		7171
	],
	"./stop.mp3": [
		11826,
		7172
	],
	"./stops.mp3": [
		11827,
		7173
	],
	"./stove.mp3": [
		11828,
		7174
	],
	"./stoves.mp3": [
		11829,
		7175
	],
	"./stripes.mp3": [
		11830,
		7176
	],
	"./summer.mp3": [
		11831,
		7177
	],
	"./sun.mp3": [
		11832,
		7178
	],
	"./sunflower.mp3": [
		11833,
		7179
	],
	"./sunny.mp3": [
		11834,
		7180
	],
	"./swim.mp3": [
		11835,
		7181
	],
	"./swimming dinosaur.mp3": [
		11836,
		7182
	],
	"./swimming.mp3": [
		11837,
		7183
	],
	"./swims.mp3": [
		11838,
		7184
	],
	"./swing.mp3": [
		11839,
		7185
	],
	"./swings.mp3": [
		11840,
		7186
	],
	"./swordfish.mp3": [
		11841,
		7187
	],
	"./t. rex.mp3": [
		11842,
		7188
	],
	"./t.mp3": [
		11843,
		7189
	],
	"./t.v.mp3": [
		11844,
		7190
	],
	"./table.mp3": [
		11845,
		7191
	],
	"./tail.mp3": [
		11846,
		7192
	],
	"./tale.mp3": [
		11847,
		7193
	],
	"./tambourine.mp3": [
		11848,
		7194
	],
	"./tambourines.mp3": [
		11849,
		7195
	],
	"./tame.mp3": [
		11850,
		7196
	],
	"./tank.mp3": [
		11851,
		7197
	],
	"./tanks.mp3": [
		11852,
		7198
	],
	"./teeth.mp3": [
		11853,
		7199
	],
	"./television.mp3": [
		11854,
		7200
	],
	"./tell.mp3": [
		11855,
		7201
	],
	"./ten.mp3": [
		11856,
		7202
	],
	"./thank.mp3": [
		11857,
		7203
	],
	"./that (libby curran's conflicted copy 2015-01-12).mp3": [
		11858,
		7204
	],
	"./that.mp3": [
		11859,
		7205
	],
	"./the.mp3": [
		11860,
		7206
	],
	"./their.mp3": [
		11861,
		7207
	],
	"./them.mp3": [
		11862,
		7208
	],
	"./then.mp3": [
		11863,
		7209
	],
	"./there.mp3": [
		11864,
		7210
	],
	"./these.mp3": [
		11865,
		7211
	],
	"./they're.mp3": [
		11866,
		7212
	],
	"./they.mp3": [
		11867,
		7213
	],
	"./thin.mp3": [
		11868,
		7214
	],
	"./thing.mp3": [
		11869,
		7215
	],
	"./things.mp3": [
		11870,
		7216
	],
	"./this.mp3": [
		11871,
		7217
	],
	"./three.mp3": [
		11872,
		7218
	],
	"./tiger.mp3": [
		11873,
		7219
	],
	"./tigers.mp3": [
		11874,
		7220
	],
	"./time.mp3": [
		11875,
		7221
	],
	"./to.mp3": [
		11876,
		7222
	],
	"./toad.mp3": [
		11877,
		7223
	],
	"./today.mp3": [
		11878,
		7224
	],
	"./too.mp3": [
		11879,
		7225
	],
	"./toucan.mp3": [
		11880,
		7226
	],
	"./toucans.mp3": [
		11881,
		7227
	],
	"./toy.mp3": [
		11882,
		7228
	],
	"./toys.mp3": [
		11883,
		7229
	],
	"./tractor.mp3": [
		11884,
		7230
	],
	"./train.mp3": [
		11885,
		7231
	],
	"./tree.mp3": [
		11886,
		7232
	],
	"./trees.mp3": [
		11887,
		7233
	],
	"./triangle.mp3": [
		11888,
		7234
	],
	"./triangles.mp3": [
		11889,
		7235
	],
	"./triceratops.mp3": [
		11890,
		7236
	],
	"./truck.mp3": [
		11891,
		7237
	],
	"./trucks.mp3": [
		11892,
		7238
	],
	"./true.mp3": [
		11893,
		7239
	],
	"./trunk.mp3": [
		11894,
		7240
	],
	"./tt.mp3": [
		11895,
		7241
	],
	"./turtle.mp3": [
		11896,
		7242
	],
	"./turtles.mp3": [
		11897,
		7243
	],
	"./tusks.mp3": [
		11898,
		7244
	],
	"./two.mp3": [
		11899,
		7245
	],
	"./u.mp3": [
		11900,
		7246
	],
	"./umbrella.mp3": [
		11901,
		7247
	],
	"./under.mp3": [
		11902,
		7248
	],
	"./underwear.mp3": [
		11903,
		7249
	],
	"./unicorn.mp3": [
		11904,
		7250
	],
	"./unicorns.mp3": [
		11905,
		7251
	],
	"./unicycle.mp3": [
		11906,
		7252
	],
	"./up.mp3": [
		11907,
		7253
	],
	"./uranus.mp3": [
		11908,
		7254
	],
	"./us.mp3": [
		11909,
		7255
	],
	"./use.mp3": [
		11910,
		7256
	],
	"./uses.mp3": [
		11911,
		7257
	],
	"./uu.mp3": [
		11912,
		7258
	],
	"./v.mp3": [
		11913,
		7259
	],
	"./vampire.mp3": [
		11914,
		7260
	],
	"./van.mp3": [
		11915,
		7261
	],
	"./vehicle.mp3": [
		11916,
		7262
	],
	"./vehicles.mp3": [
		11917,
		7263
	],
	"./velociraptor.mp3": [
		11918,
		7264
	],
	"./venus.mp3": [
		11919,
		7265
	],
	"./very.mp3": [
		11920,
		7266
	],
	"./violin.mp3": [
		11921,
		7267
	],
	"./volcano.mp3": [
		11922,
		7268
	],
	"./vv.mp3": [
		11923,
		7269
	],
	"./w.mp3": [
		11924,
		7270
	],
	"./wagon.mp3": [
		11925,
		7271
	],
	"./walrus.mp3": [
		11926,
		7272
	],
	"./want.mp3": [
		11927,
		7273
	],
	"./wants.mp3": [
		11928,
		7274
	],
	"./warm.mp3": [
		11929,
		7275
	],
	"./was.mp3": [
		11930,
		7276
	],
	"./water.mp3": [
		11931,
		7277
	],
	"./way.mp3": [
		11932,
		7278
	],
	"./we.mp3": [
		11933,
		7279
	],
	"./wear.mp3": [
		11934,
		7280
	],
	"./weather.mp3": [
		11935,
		7281
	],
	"./weigh.mp3": [
		11936,
		7282
	],
	"./went.mp3": [
		11937,
		7283
	],
	"./were.mp3": [
		11938,
		7284
	],
	"./wet.mp3": [
		11939,
		7285
	],
	"./whale shark.mp3": [
		11940,
		7286
	],
	"./whale.mp3": [
		11941,
		7287
	],
	"./whales.mp3": [
		11942,
		7288
	],
	"./what.mp3": [
		11943,
		7289
	],
	"./wheel.mp3": [
		11944,
		7290
	],
	"./wheelchair.mp3": [
		11945,
		7291
	],
	"./wheels.mp3": [
		11946,
		7292
	],
	"./when.mp3": [
		11947,
		7293
	],
	"./where.mp3": [
		11948,
		7294
	],
	"./which.mp3": [
		11949,
		7295
	],
	"./white.mp3": [
		11950,
		7296
	],
	"./who.mp3": [
		11951,
		7297
	],
	"./why.mp3": [
		11952,
		7298
	],
	"./wild animals.mp3": [
		11953,
		7299
	],
	"./wild.mp3": [
		11954,
		7300
	],
	"./will.mp3": [
		11955,
		7301
	],
	"./wind.mp3": [
		11956,
		7302
	],
	"./windy.mp3": [
		11957,
		7303
	],
	"./wings.mp3": [
		11958,
		7304
	],
	"./winter.mp3": [
		11959,
		7305
	],
	"./witch.mp3": [
		11960,
		7306
	],
	"./with.mp3": [
		11961,
		7307
	],
	"./without.mp3": [
		11962,
		7308
	],
	"./wolf cub.mp3": [
		11963,
		7309
	],
	"./wolf.mp3": [
		11964,
		7310
	],
	"./woman.mp3": [
		11965,
		7311
	],
	"./wood.mp3": [
		11966,
		7312
	],
	"./word.mp3": [
		11967,
		7313
	],
	"./words.mp3": [
		11968,
		7314
	],
	"./worm.mp3": [
		11969,
		7315
	],
	"./would.mp3": [
		11970,
		7316
	],
	"./ww.mp3": [
		11971,
		7317
	],
	"./x,y,z.mp3": [
		11972,
		7318
	],
	"./x,y,zed.mp3": [
		11973,
		7319
	],
	"./x-ray.mp3": [
		11974,
		7320
	],
	"./x-rays.mp3": [
		11975,
		7321
	],
	"./x.mp3": [
		11976,
		7322
	],
	"./xx.mp3": [
		11977,
		7323
	],
	"./xylophone.mp3": [
		11978,
		7324
	],
	"./y.mp3": [
		11979,
		7325
	],
	"./yak.mp3": [
		11980,
		7326
	],
	"./yellow.mp3": [
		11981,
		7327
	],
	"./yes.mp3": [
		11982,
		7328
	],
	"./you.mp3": [
		11983,
		7329
	],
	"./your.mp3": [
		11984,
		7330
	],
	"./youre.mp3": [
		11985,
		7331
	],
	"./yoyo.mp3": [
		11986,
		7332
	],
	"./yy.mp3": [
		11987,
		7333
	],
	"./z.mp3": [
		11988,
		7334
	],
	"./zebra.mp3": [
		11989,
		7335
	],
	"./zebras.mp3": [
		11990,
		7336
	],
	"./zed.mp3": [
		11991,
		7337
	],
	"./zee.mp3": [
		11992,
		7338
	],
	"./zero.mp3": [
		11993,
		7339
	],
	"./zipper.mp3": [
		11994,
		7340
	],
	"./zoo.mp3": [
		11995,
		7341
	],
	"./zz (libby curran's conflicted copy 2015-01-12).mp3": [
		11996,
		7342
	],
	"./zz.mp3": [
		11997,
		7343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 156;
module.exports = webpackAsyncContext;